import React from 'react';
import UnderConstruction from './gui/underconstruction'
import Home from './gui/home'
import { RequestMethods } from "./lib/request";


class App extends React.Component {

  async componentDidMount() {
    var that = this;
    that.underconstruction = true;
    this.setState({
      mode: 'mobile'
    });
  }

  componentWillUnmount() {

  }

  render() {
    // if (RequestMethods.getQueryVariable("mode") === "redesign") {
    return (<div>
      <div class='hidden' id="googleinfo">Augenstern Schmuck: Ringe, Ketten by Alexandra Gabriele Faltermeier </div>
      <Home />
    </div >
    );
    // }
    // else {
    //   return (<div>
    //     <div class='hidden' id="googleinfo">Augenstern Schmuck: Ringe, Ketten by Alexandra Gabriele Faltermeier </div>
    //     <UnderConstruction />
    //   </div>
    //   );
    // }
  }
}

export default App;
